<template lang="pug">
.ticket-picker
  ticket-card(v-if="t.type===0" v-for="(t, i) in tickets" :key="i" :ticket="t" @clicked="onSelect(t)" :active="picked === t.id")
  
</template>
<script>
import TicketCard from '@/components/res/TicketCard'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'TicketPicker',
  components: { TicketCard },
  props: {},
  data() {
    return {
      //select: -1,
    }
  },
  computed: {
    ...mapState('app', ['user', 'ticketPicked']),
    picked() {
      if (!this.ticketPicked) return -1
      else return this.ticketPicked.id
    },
    tickets() {
      console.log('组件里面的票',this.user.tickets)
      return this.user.tickets.map((t) => {
        // let body = ['儿童半价']
        let body = ['每名成人可携带一名儿童']
        // if (t.exhibits.length > 0) {
        //   body.push('包含所有展项')
        // } else {
        //   body.push('不包含以下展项体验：飞跃蚂蚁森林/DAMO 5G赛车漂移/互动区')
        // }
        let grade = null
        if (t.grade !== 'all') {
          grade = t.grade
        }
        return {
          id: t.ticketId,
          title: t.ticketName,
          point: t.ticketPoint,
          money: t.ticketMoney,
          body: body,
          grade: grade,
          type: t.ticketType,
        }
      })
    },
  },
  methods: {
    ...mapMutations('app', ['setTicketPicked','setRouterBack']),
    onSelect(t) {
      // 
      //this.select = t.id          
      this.setTicketPicked(t)
      var that = this
      setTimeout(function(){
        // that.setRouterBack('/reservation/res2')
        // that.$router.replace('/reservation/res3')
           that.setRouterBack('/reservation/res3')
           that.$router.replace('/reservation/res4')
      },500)
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
</style>
